/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, reason: NonNullable<unknown> }} Sorx_Undelivered_ManyInputs */

const en_sorx_undelivered_many = /** @type {(inputs: Sorx_Undelivered_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} messages not delivered: ${i?.reason}`)
};

const id_sorx_undelivered_many = /** @type {(inputs: Sorx_Undelivered_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pesan tidak terkirim: ${i?.reason}`)
};

/**
* | output |
* | --- |
* | "{count} messages not delivered: {reason}" |
*
* @param {Sorx_Undelivered_ManyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_undelivered_many = /** @type {((inputs: Sorx_Undelivered_ManyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Undelivered_ManyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_undelivered_many(inputs)
	return en_sorx_undelivered_many(inputs)
});